import { useEffect, useRef } from 'react';
import { isFunction } from 'lodash';
import createTimeout from '../utils/timeout/createTimeout';

export default function useSetTimeout(isClearWhenUnmount = true) {
  const timeoutClearRef = useRef();

  useEffect(
    () => () => {
      if (isFunction(timeoutClearRef.current) && isClearWhenUnmount) {
        timeoutClearRef.current();
        timeoutClearRef.current = null;
      }
    },
    [isClearWhenUnmount],
  );

  return (fn, delay) => {
    timeoutClearRef.current = createTimeout(fn, delay);
    return () => {
      timeoutClearRef.current();
      timeoutClearRef.current = null;
    };
  };
}
